import React, { useState } from 'react';
import { ShoppingCart, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { laptopBrands } from '../mockData';

const LaptopSales = () => {
  const [hoveredBrand, setHoveredBrand] = useState(null);

  return (
    <section id="sales" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2E3C5B]">
            Premium Laptop Collection
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse top brands with exclusive deals and warranty support
          </p>
          <div className="w-24 h-1 bg-[#E94B3C] mx-auto rounded-full"></div>
        </div>

        {/* Laptop Brands Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {laptopBrands.map((brand, index) => (
            <Card
              key={brand.id}
              onMouseEnter={() => setHoveredBrand(brand.id)}
              onMouseLeave={() => setHoveredBrand(null)}
              className={`overflow-hidden border-2 transition-all duration-300 cursor-pointer group ${
                hoveredBrand === brand.id
                  ? 'border-[#E94B3C] shadow-2xl -translate-y-2'
                  : 'border-gray-200 hover:border-[#2E3C5B] shadow-lg hover:shadow-xl'
              }`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Image Container */}
              <div className="relative h-64 overflow-hidden bg-gray-100">
                <img
                  src={brand.image}
                  alt={brand.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                {brand.popular && (
                  <div className="absolute top-4 right-4 bg-[#E94B3C] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
                    Popular
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* Content */}
              <div className="p-6 space-y-4">
                <h3 className="text-2xl font-bold text-[#2E3C5B] group-hover:text-[#E94B3C] transition-colors">
                  {brand.name}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {brand.description}
                </p>
                
                {/* Action Buttons */}
                <div className="flex gap-3 pt-4">
                  <Button
                    className="flex-1 bg-[#2E3C5B] hover:bg-[#1f2a3f] text-white border-0 shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                  >
                    View Models
                  </Button>


                  {/* <Button
                    variant="outline"
                    className="border-2 border-[#E94B3C] text-[#E94B3C] hover:bg-[#E94B3C] hover:text-white transition-all duration-300"
                  >
                    <ShoppingCart size={18} />
                  </Button> */}
                  
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        {/* <div className="mt-16 bg-gradient-to-r from-[#2E3C5B] to-[#1f2a3f] rounded-2xl p-12 text-center text-white shadow-2xl relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#E94B3C] rounded-full blur-3xl"></div>
          </div>
          <div className="relative z-10 space-y-6">
            <h3 className="text-3xl md:text-4xl font-bold">Looking for the Perfect Laptop?</h3>
            <p className="text-xl text-gray-200 max-w-2xl mx-auto">
              Our experts can help you choose the right laptop based on your needs and budget
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-[#E94B3C] hover:bg-[#d43d2c] text-white border-0 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 group"
              >
                Shop Online
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#2E3C5B] transition-all duration-300"
              >
                Visit Showroom
              </Button>
            </div>
          </div>
        </div> */}


      </div>
    </section>
  );
};

export default LaptopSales;
